const getCurrentGeoLocation = () =>
  new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          resolve({ lat: latitude, lng: longitude });
        },
        (error) => {
          const errorDetails = {
            message: error.message,
            code: error.code,
            isPermissionDenied: error.code === 1,
            isPositionUnavailable: error.code === 2,
            isTimeout: error.code === 3
          };
          reject(errorDetails);
        }
      );
    } else {
      reject({ message: "Geolocation is not supported by this browser.", code: 0, isPermissionDenied: false });
    }
  });

export default getCurrentGeoLocation;
